import { type Doctype } from '../types/indices';

/**
 * Adds language filtering rules for news content
 * Mimics the behavior of addLangFilter in doctypes.js
 *
 * If we are searching in News, we want the following conditions to be met:
 *    1. If we are in English, retrieve English content ONLY.
 *    2. If we are not in English, retrieve content in the user language
 *       AND English content. (Since content in other languages may be sparse).
 *
 * @param {string} filters - Existing filters
 * @param {string} doctype - Document type
 * @param {string} langid - Language identifier
 */
export function addLangFilter(doctype: Doctype, langid: string): string | null {
   if (doctype !== 'news') {
      return null;
   }

   let result = null;
   const baseFilter = 'lang:en<score=1>';
   const isEnglish = langid === 'en';

   result = isEnglish ? baseFilter : `(${baseFilter} OR lang:${langid}<score=2>)`;
   return result;
}

/**
 * Gets searchable attributes for different doctypes
 * Similar to the configuration in doctypes.js
 */
export function getSearchableAttributes(doctype: Doctype): string[] | undefined {
   const searchableAttributes: Partial<Record<Doctype, string[]>> = {
      topic: ['all_titles', 'variants', 'expanded_years', 'wiki_info'],
      // Add other doctypes' searchable attributes as needed
   };

   return searchableAttributes[doctype];
}
